import { createRoutine } from 'redux-saga-routines'

import { IAcceptInviteState } from './acceptInvite.interface'

const initialAcceptInviteState: IAcceptInviteState = {
  verificationInProgress: false,
  submitting: false,
  error: false,
  success: false,
  message: '',
  user: {}
}

export const acceptInvite = createRoutine('ACCEPT_INVITE')
export const acceptOrgInvite = createRoutine('ACCEPT_ORG_INVITE')
export const verifyInviteToken = createRoutine('VERIFY_INVITE_TOKEN')
export const resendInvite = createRoutine('RESEND_INVITE')

export default (state = initialAcceptInviteState, action: any) => {
  switch (action.type) {
    case acceptOrgInvite.TRIGGER:
    case acceptInvite.TRIGGER:
      return {
        ...state,
        error: false,
        submitting: true,
        success: false,
        message: ''
      }
    case acceptOrgInvite.SUCCESS:
    case acceptInvite.SUCCESS:
      return {
        ...state,
        error: false,
        submitting: false,
        success: true,
      }
    case acceptOrgInvite.FAILURE:
    case acceptInvite.FAILURE:
      return {
        ...state,
        error: true,
        submitting: false,
        success: false,
        message: ''
      }

    case verifyInviteToken.TRIGGER:
      return {
        ...state,
        error: false,
        verificationInProgress: true,
        success: false,
        message: ''
      }

    case verifyInviteToken.SUCCESS:
      return {
        ...state,
        error: false,
        verificationInProgress: false,
        success: true,
        user: action.payload
      }
    case verifyInviteToken.FAILURE:
      return {
        ...state,
        error: true,
        verificationInProgress: false,
        success: false,
        message: ''
      }
      case resendInvite.TRIGGER:
        return {
          ...state,
          error: false,
          submitting : true,
          success: false,
          message: ''
        }
      case resendInvite.SUCCESS:
        return {
          ...state,
          error: false,
          submitting: false,
          success: true,
        }
      case resendInvite.FAILURE:
        return {
          ...state,
          error: true,
          success: false,
          submitting: false,
          message: ''
        }
    default:
      return { ...state }
  }
}
